import { css } from 'styled-components';

import off from './images/radio_off.svg';
import on from './images/radio_on.svg';
import disabled from './images/radio_disabled.svg';
import onWithDisabled from './images/radio_on_disabled.svg';

export default css`
  margin: 0;
  border: 0;
  border-radius: 0;
  background: #fff url(${off}) center center no-repeat;
  background-size: cover;
  appearance: none;
  cursor: pointer;

  &:checked {
    background-image: url(${on});
  }

  &:disabled {
    background-image: url(${disabled});
  }

  &:checked:disabled {
    background-image: url(${onWithDisabled});
  }
`;
